"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialPreferencesState = exports.PreferencesStore = exports.Preferences = void 0;
const immutable_1 = require("immutable");
const types_1 = require("companion-app-components/flux/preferences/types");
const defaults_1 = require("./defaults");
exports.Preferences = (0, immutable_1.Record)({
    shared: {
        user: Object.assign({}, defaults_1.defaultUserPreferences),
        dataset: {
            webApp: Object.assign({}, defaults_1.defaultDatasetPreferences),
        },
    },
    /* these are not yet supported
    client: {
      user: {
      },
      dataset: {
      },
      global: {
      },
    },
    qcs: {},
    */
});
exports.PreferencesStore = (0, immutable_1.Record)({
    isLoading: undefined,
    loadPending: {
        shared: {
            user: true,
            dataset: true,
        },
    },
    preferences: new exports.Preferences(),
    error: undefined,
});
exports.initialPreferencesState = (0, types_1.mkPreferencesStore)({ preferences: new exports.Preferences() });
